import template from './template.html.twig';
import './style.scss';

import { LINKS, FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES } from '../config-links';

const { Component, Store } = Shopware;

Component.register('neti-next-incomplete-order-reminder-context-menu-plugin', {
    template,

    props: {
        pluginName: {
            type: String,
            required: false
        }
    },

    computed: {
        currentLanguage() {
            const language = Store.get('session').adminLocaleLanguage;

            if (SUPPORTED_LANGUAGES.includes(language)) {
                return language;
            }

            return FALLBACK_LANGUAGE;
        },

        documentationLink() {
            return LINKS[this.currentLanguage].documentation(this.pluginName);
        },

        supportLink() {
            return LINKS[this.currentLanguage].support();
        },

        descriptionLink() {
            return LINKS[this.currentLanguage].description(this.pluginName);
        }
    }
});